import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

/**
 * Translates the text Angular Material builds inside every `mat-paginator`.
 *
 * `selectTranslation()` follows the active language and emits once that
 * language's file has loaded, so labels update on a language switch without
 * a reload. `changes.next()` tells every paginator on screen to re-render.
 */
@Injectable()
export class TranslocoPaginatorIntl extends MatPaginatorIntl {
  private readonly transloco = inject(TranslocoService);

  constructor() {
    super();
    this.transloco.selectTranslation().subscribe(() => {
      if (this.itemsPerPageLabel !== '') {
        this.itemsPerPageLabel = this.transloco.translate('shared.paginator.itemsPerPage');
      }
      this.nextPageLabel = this.transloco.translate('shared.paginator.nextPage');
      this.previousPageLabel = this.transloco.translate('shared.paginator.previousPage');
      this.firstPageLabel = this.transloco.translate('shared.paginator.firstPage');
      this.lastPageLabel = this.transloco.translate('shared.paginator.lastPage');
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.transloco.translate('shared.paginator.rangeEmpty', { length });
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return this.transloco.translate('shared.paginator.range', { start: startIndex + 1, end: endIndex, length });
  };
}
